export const HOST = process.env.NODE_ENV === 'development' ? "https://casaideal.com.pe/blog" : "https://casaideal.com.pe/blog"